///
/// EarthBrowser
///
/// Created by Matt Giger on September 19, 2026
/// Copyright (c) 2026 Geodata Labs
///
/// Users admin section: account browsing (all per-user actions live in
/// the UserControlPanel opened by row click or the ?user=<id> query
/// param, so Ops tasks and trial-abuse views can deep-link), retention
/// cohorts, and trial-abuse analytics.
///

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useSearchParams } from 'react-router-dom'
import { RetentionSection } from './RetentionSection'
import { SigninStatsStrip } from './SigninStatsStrip'
import { TrialAbuseSection } from './TrialAbuseSection'
import { UserControlPanel } from './UserControlPanel'
import { UserManagementTable } from './UserManagementTable'

export function UsersSection() {
  const [searchParams, setSearchParams] = useSearchParams()

  const userParam = parseInt(searchParams.get('user') ?? '')
  const selectedUserId = Number.isInteger(userParam) && userParam > 0 ? userParam : null

  const openUser = (userId: number) => {
    const params = new URLSearchParams(searchParams)
    params.set('user', String(userId))
    setSearchParams(params)
  }

  const closeUser = () => {
    const params = new URLSearchParams(searchParams)
    params.delete('user')
    setSearchParams(params)
  }

  return (
    <>
      {selectedUserId !== null && (
        <UserControlPanel userId={selectedUserId} onClose={closeUser} />
      )}

      <Tabs defaultValue="accounts" className="space-y-5">
        <TabsList className="rounded-full">
          <TabsTrigger value="accounts" className="rounded-full">Accounts</TabsTrigger>
          <TabsTrigger value="retention" className="rounded-full">Retention</TabsTrigger>
          <TabsTrigger value="trial-abuse" className="rounded-full">Trial Abuse</TabsTrigger>
        </TabsList>
        <TabsContent value="accounts" className="space-y-5">
          <SigninStatsStrip />
          <UserManagementTable onSelectUser={openUser} />
        </TabsContent>
        <TabsContent value="retention">
          <RetentionSection />
        </TabsContent>
        <TabsContent value="trial-abuse">
          <TrialAbuseSection onSelectUser={openUser} />
        </TabsContent>
      </Tabs>
    </>
  )
}
